import React from 'react';
import { DoneDealInvestorsPanel } from './investorsPanel';
import ConnectorDeals from './ConnectorDeals';
import { ConnectorDeal, ConnectorDealStatus } from '../../../types/types';
import { useConnectorDeals } from '../../../contexts';

const ConnectorDealsDone = () => {
  const { doneDeals, doneDealsTotalCount } = useConnectorDeals();

  const renderRightPanelContent = (deal: ConnectorDeal) => (
    <DoneDealInvestorsPanel
      investorsList={deal.referrals}
      entProfileId={deal.entrepreneurProfileId}
    />
  );
  return (
    <ConnectorDeals
      renderRightPanelContent={renderRightPanelContent}
      status={ConnectorDealStatus.Done}
      // eslint-disable-next-line react/jsx-props-no-spreading
      deals={doneDeals}
      totalCount={doneDealsTotalCount}
    />
  );
};

export default ConnectorDealsDone;
